import OrderStatus from './order-status';

export default OrderStatus;
export { OrderStatus };
